const pad0 = { left: 0, right: 0, top: 0, bottom: 0 };
const flippedPlacement = {
    bottom: 'top',
    right: 'left',
    top: 'bottom',
    left: 'right',
};
// 延展的方向（水平或者竖直方向）
function getAxis(placement) {
    return placement === 'bottom' || placement === 'top' ? 'y' : 'x';
}
function getWH(placement) {
    return getAxis(placement) === 'x' ? 'width' : 'height';
}
// 计算过程中的正负号
function getDirection(placement) {
    return placement === 'bottom' || placement === 'right' ? 1 : -1;
}
// 对齐的方向
function getAlignPlacement(alignment, placement) {
    if (placement === 'bottom' || placement === 'top') {
        return alignment === 'end' ? 'left' : 'right';
    }
    return alignment === 'end' ? 'top' : 'bottom';
}
// 翻转之后的坐标
function getPosition(placement, pos, edge) {
    const newPos = {};
    const axis = getAxis(placement);
    const direction = getDirection(placement);
    newPos[axis] = direction * (pos[axis] + edge[placement]);
    return { ...pos, ...newPos };
}
// 修改 box 的尺寸
function changeBox(box, size) {
    const isNumber = typeof size === 'number';
    ['left', 'right', 'top', 'bottom'].forEach((placement) => {
        box[placement] += isNumber ? size : size[placement];
    });
    return box;
}
// 确定位置
function place(options) {
    const gap = options.gap || 0;
    const pad = options.pad || 0;
    return function ({ pos, placement, rects }) {
        const side = changeBox({
            bottom: rects.ref.height,
            right: rects.ref.width,
            top: rects.target.height,
            left: rects.target.width,
        }, gap);
        // 与各个方向的距离
        const edge = changeBox({
            bottom: rects.ref.y +
                side.bottom +
                rects.target.height -
                (rects.boundary.y + rects.boundary.height),
            right: rects.ref.x +
                side.right +
                rects.target.width -
                (rects.boundary.x + rects.boundary.width),
            top: rects.boundary.y - (rects.ref.y - side.top),
            left: rects.boundary.x - (rects.ref.x - side.left),
        }, pad);
        // 使用溢出较少的一侧
        const usedPlacement = Math.max(0, edge[placement]) >
            Math.max(0, edge[flippedPlacement[placement]])
            ? flippedPlacement[placement]
            : placement;
        const newPos = getPosition(usedPlacement, pos, side);
        return {
            ...newPos,
            placement: usedPlacement,
            availableSize: rects.target[getWH(usedPlacement)] - edge[usedPlacement],
        };
    };
}
// 边缘对齐
function align(options) {
    const alignment = options.alignment || 'start';
    const pad = !options.pad || typeof options.pad === 'number'
        ? changeBox({ ...pad0 }, options.pad || 0)
        : options.pad;
    return function ({ pos, placement, rects }) {
        // 在与放置方向垂直的方向进行对齐
        const tmpPlacement = getAlignPlacement(alignment, placement);
        const axis = getAxis(tmpPlacement);
        const direction = getDirection(tmpPlacement);
        const widthOrHeight = getWH(tmpPlacement);
        const newPos = { ...pos };
        if (alignment === 'center') {
            newPos[axis] +=
                (rects.ref[widthOrHeight] - rects.target[widthOrHeight]) / 2;
        }
        else if (alignment === 'end') {
            newPos[axis] += rects.ref[widthOrHeight] - rects.target[widthOrHeight];
        }
        // 对齐边界
        const edge = {
            bottom: rects.boundary.y + rects.boundary.height - pad.bottom,
            right: rects.boundary.x + rects.boundary.width - pad.right,
            top: rects.boundary.y + pad.top,
            left: rects.boundary.x + pad.left,
        };
        const side = {
            bottom: rects.base.y + newPos.y + rects.target.height,
            right: rects.base.x + newPos.x + rects.target.width,
            top: rects.target.y,
            left: rects.target.x,
        };
        const length = edge[tmpPlacement] - side[tmpPlacement];
        if (direction * length < 0) {
            newPos[axis] += length;
        }
        return { ...newPos };
    };
}
// 调整边缘
function adjust(options) {
    const pad = !options.pad || typeof options.pad === 'number'
        ? changeBox({ ...pad0 }, options.pad || 0)
        : options.pad;
    return function ({ pos, placement, rects, delta }) {
        const edge = {
            bottom: rects.boundary.y + rects.boundary.height - pad.bottom,
            right: rects.boundary.x + rects.boundary.width - pad.right,
            top: rects.boundary.y + pad.top,
            left: rects.boundary.x + pad.left,
        };
        const side = {
            bottom: rects.base.y + pos.y + rects.target.height,
            right: rects.base.x + pos.x + rects.target.width,
            top: rects.base.y + pos.y,
            left: rects.base.x + pos.x,
        };
        // 计算剩余空间宽度
        const available = {
            width: edge.right - edge.left,
            height: edge.bottom - edge.top,
        };
        const axis = getAxis(placement);
        const wh = getWH(placement);
        const availableSpace = available[wh] - rects.target[wh];
        if (availableSpace < 0) {
            // TODO: 是否需要修改目标宽高？
            return {};
        }
        // 四个方向，只选一个方向调整
        const newPos = { ...pos };
        if (axis === 'y' && side.left < edge.left) {
            // 右移
            newPos.x += edge.left - side.left;
        }
        else if (axis === 'y' && side.right > edge.right) {
            // 左移
            newPos.x -= side.right - edge.right;
        }
        else if (axis === 'x' && side.top < edge.top) {
            // 下移
            newPos.y += edge.top - side.top;
        }
        else if (axis === 'x' && side.bottom > edge.bottom) {
            // 上移
            newPos.y -= side.bottom - edge.bottom;
        }
        const newDelta = {
            x: delta.x - (newPos.x - pos.x),
            y: delta.y - (newPos.y - pos.y),
        };
        return { ...newPos, delta: newDelta, placement };
    };
}
// 获取去要参与位置计算的所有 box
function getRects(target, ref, boundary) {
    const refRect = typeof ref === 'function' ? ref(target) : ref.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    const viewportRect = {
        x: 0,
        y: 0,
        // 理想的情况下，这里应该使用 documentElement.clientWidth/clientHeight 来排除
        // 滚动条的尺寸，但在无界等沙箱方案中，documentElement 并非是、并且我们也没有简单
        // 的手段去获得，最外层（也就是父应用）的 documentElement。所以这里用了 window，
        // 可能会出现弹出元素被视口的滚动条覆盖的情况，这种情况可以使用 --exeditor-edge-right、
        // --exeditor-edge-bottom 等 CSS 变量来调整避让。
        width: window.innerWidth,
        height: window.innerHeight,
    };
    let boundaryRect;
    if (boundary) {
        boundaryRect = boundary.getBoundingClientRect();
        const left = Math.max(boundaryRect.x, viewportRect.x);
        const top = Math.max(boundaryRect.y, viewportRect.y);
        const right = Math.min(boundaryRect.x + boundaryRect.width, viewportRect.x + viewportRect.width);
        const bottom = Math.min(boundaryRect.y + boundaryRect.height, viewportRect.y + viewportRect.height);
        boundaryRect = {
            x: left,
            y: top,
            width: right - left,
            height: bottom - top,
        };
    }
    else {
        boundaryRect = viewportRect;
    }
    const container = target.offsetParent;
    let baseRect;
    if (container && container.nodeName !== 'body') {
        baseRect = container.getBoundingClientRect();
    }
    else {
        const htmlRect = document.documentElement.getBoundingClientRect();
        baseRect = {
            x: 0,
            y: 0,
            width: htmlRect.width,
            height: htmlRect.height,
        };
    }
    return {
        ref: refRect,
        target: targetRect,
        base: baseRect,
        boundary: boundaryRect,
    };
}
export function computePopPosition(options) {
    const originalPlacement = options.placement || 'top';
    let placement = originalPlacement;
    const { target, ref, boundary } = options;
    const rects = getRects(target, ref, boundary);
    let x = rects.ref.x - rects.base.x;
    let y = rects.ref.y - rects.base.y;
    let availableSize = Infinity;
    let delta = { x: 0, y: 0 };
    [
        place({ gap: options.gap, pad: options.pad }),
        align({ alignment: options.alignment, pad: options.pad }),
        adjust({}),
    ].forEach((fn) => {
        var _a, _b, _c, _d, _e;
        const pos = { x, y };
        const tmp = fn({
            pos,
            delta,
            placement,
            originalPlacement,
            availableSize,
            rects,
        });
        x = (_a = tmp.x) !== null && _a !== void 0 ? _a : x;
        y = (_b = tmp.y) !== null && _b !== void 0 ? _b : y;
        placement = (_c = tmp.placement) !== null && _c !== void 0 ? _c : placement;
        availableSize = (_d = tmp.availableSize) !== null && _d !== void 0 ? _d : availableSize;
        delta = (_e = tmp.delta) !== null && _e !== void 0 ? _e : delta;
    });
    return {
        x,
        y,
        placement,
        availableSize,
        delta,
    };
}
//# sourceMappingURL=pop.js.map